import IframeUtility from './IframeUtility.js';

/**
 * IframeVisibleArea.
 */
export default class IframeVisibleArea {
	private static isInsideIframe = IframeUtility.isInsideIframe();
	private static isParentWindowAccessible = IframeUtility.isParentWindowAccessible();

	/**
	 * Returns bottom, top, left and right.
	 *
	 * @param overflow Overflow.
	 * @returns Position.
	 */
	public static getArea(overflow: boolean): {
		top: number;
		bottom: number;
	} {
		if (!this.isInsideIframe) {
			throw 'IframeVisibleArea only works when it is called from inside an iframe';
		} else if (!this.isParentWindowAccessible) {
			throw 'Could not get visible iframe area. Parent window is not accessible.';
		}

		// TODO: Remove header height as we can't calculate it anymore after we removed uiPlatform from settings.
		const headerHeight = 0;
		const pageHeight = document.body.offsetHeight;
		const screenHeight = window.parent.innerHeight;

		if (!window.frameElement) {
			throw new Error('No frameElement available on window');
		}
		const frameRect = window.frameElement.getBoundingClientRect();
		const positionBottom = pageHeight + frameRect.top - screenHeight;

		const position = {
			top: frameRect.top < headerHeight ? -1 * frameRect.top + headerHeight : 0,
			bottom: positionBottom > 0 ? positionBottom : 0
		};

		if (overflow) {
			const pageBodyHeight = 320;
			position.top = frameRect.top < headerHeight ? -1 * frameRect.top + headerHeight : 0;
			position.bottom = positionBottom > 0 ? positionBottom : 0;

			const topOffset = pageHeight - position.bottom - position.top;

			position.top -= topOffset < pageBodyHeight ? pageBodyHeight - topOffset : 0;
			position.top = position.top > 0 ? position.top : 0;

			const bottomOffset = pageHeight - position.bottom - position.top;

			position.bottom -= bottomOffset < pageBodyHeight ? pageBodyHeight - bottomOffset : 0;
			position.bottom = position.bottom > 0 ? position.bottom : 0;
			return position;
		} else {
			return position;
		}
	}
}
